import type { EMMIconName, IPopup } from '@mm-frontend/mm-web-ui-kit';
import type { RouteLocationRaw, Router } from 'vue-router';
import type { ERouteName } from '~/app/router/routeName.enum';

export enum EBottomBarItem {
  HOME = 'home',
  CATALOG = 'catalog',
  CART = 'cart',
  FAVORITE = 'favorite',
  USER = 'user',
}

export type IBottomBarItem = {
  title: string;
  icon: EMMIconName;
  name: EBottomBarItem;
  modalName?: EBottomBarItem;
  activeRoutes?: ERouteName[];
  router: Router;
  callback?: () => void;
}

export type IBottomBarItemNavigator = IBottomBarItem & {
  navigateTo: RouteLocationRaw;
}

export type IBottomBarItemModal = IBottomBarItem & {
  popup: IPopup;
}